import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import { shipmentFragment } from "@saleor/fragments/shipment";
import makeQuery from "@saleor/hooks/makeQuery";
// import { ShipmentDetailsVariables } from "@saleor/instagram/types/ShipmentDetails";
import gql from "graphql-tag";

import {
  ShipmentDetails,
  ShipmentDetailsVariables
} from "./types/ShipmentDetails";
import { ShipmentList, ShipmentListVariables } from "./types/ShipmentList";

const shipmentList = gql`
  ${pageInfoFragment}
  query ShipmentList(
    $filter: ShipmentFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    shipments(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        node {
          id
          shipmentCompany
          orderNumber
          trackingNumber
          trackingCode
          totalWeight
          shipedDate
          shipedDelivered
          shippingDetails
          shipmentInfo
          courierCode
          sku
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useShipmentListQuery = makeQuery<
  ShipmentList,
  ShipmentListVariables
>(shipmentList);

const shipmentDetails = gql`
  ${shipmentFragment}
  query ShipmentDetails($id: ID!) {
    shipment(id: $id) {
      ...shipmentFragment
    }
  }
`;
// console.log(shipmentDetails)
export const useShipmentDetailsQuery = makeQuery<
  ShipmentDetails,
  ShipmentDetailsVariables
>(shipmentDetails);
